import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './ConnectPop.module.css';
import pageStylePops from './pageStylePops.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import { theMenuItems } from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import MyFunctions from '../Functions/MyFunctions';
import { UserContext } from '../Contexts/User_Context';

const PaymentTypePop = (props) => {
    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);

    const [pageDetails, setPageDetails] = useState();
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("WelcomePop")
            setPageDetails(pg);
        }
        getPageDetalis();

    }, [])

    useEffect(() => {
    }, [mobiOrNot]);


    const payType = (tp) => {

        let theORd = { ...props.theOrd }
        theORd.PaymentType = tp;
        props.theFunction(theORd)
    }

    const closeIt = () => {
        props.closeMeFuc();
    }

    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            <div className={`${pageStylePops.loginPageBtns} inBackMiiddleGold inColorBlack pointing`} onClick={() => payType(0)}>
                <div>אשראי</div>
            </div>
            <div className={`${pageStylePops.loginPageBtns} inBackBlue inColorWhite pointing`} onClick={() => payType(1)}>
                <div>מזומן</div>
            </div>

        </div>
    );
}

export default PaymentTypePop;